import type { UserSettings, UserSettingsResponse } from '../types';

/**
 * 更新用户设置请求参数
 */
export interface UpdateUserSettingsRequest {
    /** 需要更新的设置字段 */
    settings: UserSettings;
}

export const UserSettingsApi = Symbol.for('UserSettingsApi');

/**
 * 用户设置 API 接口
 */
export interface UserSettingsApi {
    /**
     * 获取当前用户设置
     */
    getUserSettings(): Promise<UserSettingsResponse>;

    /**
     * 更新当前用户设置
     * @param request 更新请求参数
     */
    updateUserSettings(request: UpdateUserSettingsRequest): Promise<UserSettingsResponse>;
}

